import {cn} from '@sollapay/ui';
import {Typography} from '@sollapay/ui/components';

import type {AssetFact} from './asset-header.utils';
import type {FC} from 'react';

export interface AssetFactItemProps {
  fact: AssetFact;
  /** First item in the row skips the leading divider rule. */
  isFirst?: boolean;
}

export const AssetFactItem: FC<AssetFactItemProps> = ({fact, isFirst = false}) => (
  <div
    data-slot="asset-fact"
    className={cn(
      'relative flex items-baseline gap-1.5',
      // A rule centred in the preceding gap, so no separator character reaches copy-paste.
      !isFirst && 'before:absolute before:inset-y-1 before:-start-2 before:w-px before:bg-border'
    )}
  >
    <dt>
      <Typography as="span" size="xs" className="text-fg-quaternary">
        {fact.label}
      </Typography>
    </dt>
    <dd>
      <Typography as="span" size="sm" weight="semibold">
        {fact.value}
      </Typography>
    </dd>
  </div>
);
